import { commandCenterApi } from '../services/api'

// LegSearch keys its cache by scope. Command Center searches by provider and
// destinations instead of an organization slug, so the scope is both.
export function commandCenterLegSearchScope(providerId, destinations) {
  return `command-center:${providerId}:${JSON.stringify(destinations)}`
}

// Every regulation the destinations search, once, for LegSearch's
// "x/y regulations" note.
export function commandCenterLegSearchOfferings(destinations) {
  return [...new Set(destinations.flatMap((destination) => destination.regulation_ids))]
}

// LegSearch's search(request, { signal }) for the destination-scoped route.
export function createCommandCenterLegSearch(providerId, destinations) {
  return (request, { signal } = {}) => commandCenterApi.searchKambiLegsV2(providerId, {
    query: request.q,
    destinations,
    eventStatus: request.eventStatus,
    cursor: request.cursor,
    searchSession: request.searchSession,
    searchSeq: request.searchSeq,
  }, { signal })
}
